module.exports = __webpack_public_path__ + "img/pauta.b3048b03.jpg";